import { ApiClient } from './client.js'
import { TEAM_COLLECTIONS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (collectionId) {
    return client.get(`${TEAM_COLLECTIONS}${collectionId}/`)
  },

  list () {
    return client.get(`${TEAM_COLLECTIONS}`)
  },

  listAll () {
    return client.getAll(`${TEAM_COLLECTIONS}`)
  },

  lite () {
    return client.get(`${TEAM_COLLECTIONS}lite/`)
  },

  liteAll () {
    return client.getAll(`${TEAM_COLLECTIONS}lite/`)
  },

  create (data) {
    return client.post(`${TEAM_COLLECTIONS}`, data)
  },

  delete (collectionId) {
    return client.delete(`${TEAM_COLLECTIONS}${collectionId}/`)
  },

  partialUpdate (collectionId, data) {
    return client.patch(`${TEAM_COLLECTIONS}${collectionId}/`, data)
  },

  addItems (collectionId, data) {
    return client.post(`${TEAM_COLLECTIONS}${collectionId}/add_tracks/`, data)
  }
}
